import { render, staticRenderFns } from "./importJsonModal.vue?vue&type=template&id=72242b82&scoped=true"
import script from "./importJsonModal.vue?vue&type=script&lang=js"
export * from "./importJsonModal.vue?vue&type=script&lang=js"
import style0 from "./importJsonModal.vue?vue&type=style&index=0&id=72242b82&prod&lang=less"
import style1 from "./importJsonModal.vue?vue&type=style&index=1&id=72242b82&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72242b82",
  null
  
)

export default component.exports